<template>
  <div class="page-content">
    <div class="remmcond">
      <!-- <div class="rem_item" v-for="(item,index) in 4" :key="index">
        <img src="@/assets/icon_product.png">
        <span>专用完全培养基</span>
      </div>-->
      <CateBanner v-if="subCateList.length > 0" :items="subCateList" :interval="3000" />
    </div>
    <div class="bannerss">
      <video ref="video" :src="currentCategory.video" class="banner1_img" v-if="currentCategory.video"
        :controls="false"></video>
      <img :src="currentCategory.thumb" class="banner1_img" v-else>
    </div>
    <div class="video" v-if="currentCategory.video">
      <img src="@/assets/icon_video_play.png" @click="playVideo">
      <img src="@/assets/icon_video_pause.png" @click="pauseVideo">
    </div>
    <div class="banner22s" v-loading="loading" v-if="associationCategoryGoods.length > 0">
      <span class="banner22s_span">{{ associationCategoryGoods[0].title }}</span>
      <GoodsBanner :items="associationCategoryGoods[0].goods" :cateid="associationCategoryGoods[0].id" :interval="3000" />
    </div>
    <template v-if="associationCategoryGoods.length > 1">
      <div class="banner22s"  v-loading="loading" v-for="(item, index) in associationCategoryGoods.slice(1)" :key="index">
        <span class="banner22s_span">{{ item.title }}</span>
        <div class="carousel-container" v-if="item.goods.length > 0">
          <!-- 图片列表 -->
          <div class="carousel-track flex-wrap">
            <!-- 循环渲染双倍图片实现无缝衔接 -->
            <div v-for="(goods, goodsIndex) in item.goods" :key="goodsIndex" class="item"
              :class="currentIndexList[index] == goodsIndex ? 'carousel-item4' : 'carousel-item3'" @click="goGoods(goods.id,item.id)" @mouseover="mouseoverClick(index,goodsIndex)">
              <img :src="goods.thumb" class="carousel-item2_img2">
              <span class="goods-title">{{ goods.title }}</span>
            </div>
          </div>
        </div>
        <div class="carousel-container" v-else>
          <el-empty description="暂无数据"></el-empty>
        </div>
      </div>
    </template>


    <div class="banner22s">
      <span class="banner22s_span">意向采购</span>
      <div class="carousel-container">
        <!-- 图片列表 -->
        <div class="carousel-track">
          <!-- 循环渲染双倍图片实现无缝衔接 -->
          <div v-for="(item, index) in imageList2" :key="index" class="carousel-item2"
            @mouseover="handleMouseover(index)" @click="$router.push(item.link)">
            <img :src="currentIndex == index ? item.imgbg1 : item.imgbg2" class="carousel-item2_img">
            <div class="ccs_inner_data">
              <img :src="currentIndex == index ? item.img1 : item.img2">
              <span :class="currentIndex == index ? 'text1' : 'text2'">{{ item.title }}</span>
              <span class="text3" v-if="currentIndex == index">探索了解</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bus from "@/components/eventBus.js";
import { mapGetters,mapActions } from 'vuex'
import GoodsBanner from "@/components/GoodsBanner";
import CateBanner from "@/components/CateBanner";
export default {
  name: "CellsLine",
  components: { GoodsBanner, CateBanner },
  data() {
    return {
      currentIndex: 0,
      loading: false,
      subCateList: [],
      currentCategory: {},
      imageList2: [
        {
          imgbg1: require("@/assets/icon_cgyx_s.png"),
          imgbg2: require("@/assets/icon_cgyx_n.png"),
          title: "代理商",
          img1: require("@/assets/icon_cgyx_dls_n.png"),
          img2: require("@/assets/icon_cgyx_dls_s.png"),
          link: "/postdetail/4"
        },
        {
          imgbg1: require("@/assets/icon_cgyx_s.png"),
          imgbg2: require("@/assets/icon_cgyx_n.png"),
          title: "产品包装",
          img1: require("@/assets/icon_cgyx_cpbz_n.png"),
          img2: require("@/assets/icon_cgyx_bpbz_s.png"),
          link: "/postdetail/7"
        },
        {
          imgbg1: require("@/assets/icon_cgyx_s.png"),
          imgbg2: require("@/assets/icon_cgyx_n.png"),
          title: "保存和使用",
          img1: require("@/assets/icon_cgyx_sy_n.png"),
          img2: require("@/assets/icon_cgyx_sy_s.png"),
          link: "/postdetail/8"
        }
      ],
      currentIndexList:[-1,-1],
      associationCategoryGoods: []

    };
  },
  computed: {
    ...mapGetters(['base'])
  },
  watch: {
    base: {
      handler(newVal) {
        if (newVal.category && newVal.category.length > 0) {
          console.log(newVal.category, this.$route.params.id)
          // 查找 匹配 id的分类的子分类
          this.currentCategory = newVal.category.find(item => item.id == this.$route.params.id)
          this.subCateList = this.currentCategory.child.map(item => {
            return {
              id: item.id,
              name: item.title,
              img: item.thumb
            }
          })
          console.log('subCateList is', this.subCateList)
        }

      },
      immediate: true
    },
    '$route.params.id': {
      handler(newVal) {
        this.getAssociationCategoryGoods()
        this.getConfig()
        if (this.base.category && this.base.category.length > 0) {
          this.subCateList = this.base.category.find(item => {
            return item.id == newVal
          }).child.map(item => {
            return {
              id: item.id,
              name: item.title,
              img: item.thumb
            }
          })
        }
      },
      immediate: true
    }
  },
  created() {
    
  },
  mounted() { },
  methods: {
    ...mapActions(['getConfig']),
    handleMouseover(index) {
      this.currentIndex = index
    },
    mouseoverClick(index,goodsIndex) {
      this.$set(this.currentIndexList,index,goodsIndex)
    },
    playVideo() {
      this.$refs.video.play()
    },
    pauseVideo() {
      this.$refs.video.pause()
    },
    goGoods(id,cateid) {
      this.$router.push({ path: "/productinfo/" + id + "?cateid=" + cateid })
    },
    async getAssociationCategoryGoods() {
      this.loading = true
      try {
        const res = await this.$api.getAssociationCategoryGoods({ category_id: this.$route.params.id })
        if (res.code == 1) {
          this.associationCategoryGoods = res.data.list
          this.currentIndexList = new Array(this.associationCategoryGoods.length-2).fill(-1)
        } else {
          this.associationCategoryGoods = []
        }
        console.log(res)
      } catch (err) {
        console.log(err)
        this.$message.error(err.message)
      } finally {
        this.loading = false
      }
    }

  }
};
</script>

<style lang="less" scoped>
.page-content{
  padding-top: 100px;
}
.user_body {
  background: #ffffff;
  margin-left: 15%;
  margin-right: 15%;
  box-sizing: border-box;
  margin-top: 30px;
}

.remmcond {
  // margin-left: 15%;
  // margin-right: 15%;
  // display: flex;
  // flex-direction: row;
  // justify-content: center;
  // align-items: center;
  // flex-wrap: wrap;
  margin-top: 25px;
  margin-bottom: 20px;
}

.banner33s {
  margin-left: 15%;
  margin-right: 15%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.bannerss {
  height: 540px;
}

.banner1_img {
  height: 540px !important;
  width: 100%;
  object-fit: cover;
}

.rem_item {
  width: 280px;
  height: 330px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 1%;
  margin-top: 18px;
}

.rem_item img {
  width: 280px;
  height: 280px;
}

.rem_item span {
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
}

.video {
  display: flex;
  flex-direction: column;
  z-index: 9999999;
  width: 100%;
  height: 100px;
  justify-content: flex-end;
  align-items: flex-end;
  margin-top: -120px;
  position: absolute;
  padding-right: 50px;
  box-sizing: border-box;
}

.video img {
  width: 44px;
  height: 44px;
  margin-bottom: 10px;
}

.banner22s {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}

.banner22s_span {
  margin-left: 18%;
  color: #000000;
  font-size: 44px;
  line-height: 64px;
  margin-bottom: 15px;
}

.carousel-container {
  margin-left: 18%;
  margin-right: 18%;
}

.carousel-track {
  height: 100%;
  width: 100%;
  /* 双倍宽度容纳重复图片 */
  display: flex;

  height: 330px;
  &.flex-wrap{
    flex-wrap: wrap;
  }
  .item{

  }
}

.carousel-item {
  flex: 0 0 24%;
  /* 每张占25%宽度 */
  width: 280px;
  height: 330px;
  box-sizing: border-box;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
}

.carousel-item img {
  width: 100%;
  height: 280px;
  object-fit: cover;
}

.carousel-item span {
  height: 50px;
  width: 280px;
  text-align: center;
  font-size: 16px;
  line-height: 50px;
  color: #333333;
}

.carousel-item2 {
  cursor: pointer;
  flex: 0 0 32.4%;
  /* 每张占25%宽度 */
  width: 280px;
  height: 264px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
  position: relative;
}

.carousel-item2_img {
  width: 100%;
  height: 264px;
  object-fit: cover;
  background: rgba(60, 156, 143, 0.30);
}

.carousel-item3 {
  cursor: pointer;  
  flex: 0 0 24%;
  /* 每张占25%宽度 */
  width: 280px;
  height: 330px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
  position: relative;
  background: #ffffff;
  box-shadow: 0px 0px 20px #eeeeee;
}

.carousel-item4 {
  cursor: pointer;  
  flex: 0 0 24%;
  /* 每张占25%宽度 */
  width: 280px;
  height: 330px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
  position: relative;
  background: #ffffff;
  box-shadow: 0px 0px 20px #aaaaaa;
}

.carousel-item2_img2 {
  width: 100%;
  height: 264px;
  object-fit: cover;
}
.goods-title{
  width: 90%;
padding: 10px 10px;
font-family: Source Han Sans, Source Han Sans;
font-weight: 400;
font-size: 20px;
color: #3E3E3E;
text-align: center;
text-overflow: ellipsis;
white-space: nowrap;
overflow: hidden;
}
.cgyx {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 18%;
  margin-right: 18%;
}

.cgyx_top {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.ccs_inner_data {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
}

.text1 {
  color: #ffffff;
  font-size: 28px;
  line-height: 41px;
  margin-top: 10px;
}

.text2 {
  color: #3c9c8f;
  font-size: 28px;
  line-height: 41px;
  margin-top: 10px;
}

.text3 {
  color: #ffffff;
  font-size: 14px;
  line-height: 40px;
  width: 120px;
  height: 40px;
  margin-top: 10px;
  text-align: center;
  background: #e69f3e;
}
</style>
